// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Kutz-","logo":"Header_logo__ZCeeA","auth":"Header_auth__SjUmJ"};